import store from 'app/store';

export default function getUserId(state) {
  try {
    const { auth } = state || store.get().getState();
    return auth.get('userId');
  } catch (e) {
    return undefined;
  }
}
